
import moment from 'moment';
import { Component, Vue, Mixins } from 'vue-property-decorator';
import { getUserList, getUserDisable, getUserRole } from '@/api/userManaging';
import { PageQuery } from '@/mixins/page_query';
import LogUtils from 'panda-log';
import { toast } from '../../../utils/common';
import { iSelectOptionsList } from '../../../interface/cancel-detail';
import InvitationDetail from './invitation_detail.vue';
@Component({
  filters: {
    local_time_str(val: number) {
      return moment(val * 1000).format('YYYY-MM-DD HH:mm:ss');
    },
    hour_miniute(mint: number) {
      let hour: number;
      let miniute: number;
      miniute = mint % 60;

      if (mint > 60) {
        hour = Math.floor(mint / 60);
        if (miniute === 0) {
          return `${hour}小时`;
        } else {
          return `${hour}小时${miniute}分`;
        }
      } else if (mint === 60) {
        return `${mint}分钟`;
      } else {
        return `${miniute}分钟`;
      }
    },
  },
  components: { InvitationDetail },
})
export default class RechargeRecord extends Mixins(PageQuery) {
  private start!: any;
  private end!: any;
  private dates = '';
  private invitetionVisible: boolean = false;
  private info: any;
  private pickerOptions = {
    shortcuts: [
      {
        text: '最近一周',
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit('pick', [start, end]);
        },
      },
      {
        text: '最近一个月',
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit('pick', [start, end]);
        },
      },
      {
        text: '最近三个月',
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit('pick', [start, end]);
        },
      },
    ],
  };

  public page_query = {
    page: 1,
    page_size: 30,
  };

  handleSizeChange(val: number) {
    // Cookies.set('page_size_ck', val.toString());
    this.page_query.page_size = val;
    this.page_query.page = 1;
    this.pageFn && this.pageFn();
  }
  handleCurrentChange(val: number) {
    this.page_query.page = val;
    this.pageFn && this.pageFn();
  }

  // private statusArr = ['全部类型', '正常', '黑名单'];
  private statusArr: iSelectOptionsList[] = [
    {
      label: '普通',
      value: 1,
    },
    {
      label: '黑名单',
      value: 2,
    },
    {
      label: '推广员',
      value: 3,
    },
  ];
  hasPhone: iSelectOptionsList[] = [
    {
      label: '全部',
      value: 0,
    },
    {
      label: '有',
      value: 2,
    },
    {
      label: '无',
      value: 1,
    },
  ];
  private tableData = [
    // {
    //   created_at: -89316166.37838253,
    //   coin: -79481865.03881139,
    //   duration: 120,
    //   id: 27646955.737832665,
    //   is_disable: false,
    //   nickname: 'e',
    // },
  ];

  private query = {
    role: '',
    nickname: '',
    uid: '',
    invite_id: '',
    ygx_id: '',
  };

  private loading = false;
  // private is_disable = false;

  dateHandler(e: any) {
    if (!e) {
      this.start = '';
      this.end = '';
      return;
    }
    this.start = moment(e[0], 'YYYY-MM-DD').unix();
    this.end = moment(e[1])
      .endOf('day')
      .unix();
  }
  searchList() {
    this.page_query.page = 1;
    this.getList();
  }
  switchChange(item: any) {
    if (item.is_disable == 1) {
      const h = this.$createElement;
      this.$msgbox({
        title: '提示',
        message: '是否确认禁用该账号吗？',
        // message: h(
        //   'p',
        //   { style: 'text-align: center' },
        //   ' 是否确认禁用该账号吗？ ' /* [h('span', { style: 'text-align: center' }, ' 是否确认禁用该账号吗？ ')] */
        // ),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '执行中...';
            this.loading = true;
            this.editUserDisable(item);
            done();
            instance.confirmButtonLoading = false;
          } else if (action === 'cancel') {
            item.is_disable = 0;
            done();
          }
        },
      }).then(action => {
        //done();
      });
      return;
    }
    this.loading = true;
    this.editUserDisable(item);
  }
  handleBatch(command: any) {
    if (command.value == 2) {
      this.invitetionVisible = true;
      this.info = command.row;
      return;
    }
    let message = '确认设置为' + command.type + '吗？';
    this.$msgbox({
      title: '提示',
      message: message,
      // type: 'warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          this.loading = true;
          this.setUserRole(command.value, command.uid);
          done();
          instance.confirmButtonLoading = false;
        } else if (action === 'cancel') {
          done();
        }
      },
    }).then(action => {
      //done();
    });
  }
  async getList() {
    try {
      this.loading = true;
      const query = {
        ...this.page_query,
        ...this.query,
        start: this.start,
        end: this.end,
      };
      const res = await getUserList(query);
      if (res && (res as any).code === 0) {
        this.tableData = res.data.list;
        this.total = res.data.total;
      }
      this.loading = false;
    } catch (error) {
      LogUtils.debug(error);
    } finally {
      this.loading = false;
    }
  }
  async editUserDisable(item: any) {
    try {
      const res = await getUserDisable({ disable: item.is_disable == 1 ? true : false, uid: item.id });
      if (res && res.code == 0) {
        this.getList();
      }
      this.loading = false;
    } catch (error) {
      LogUtils.debug(error);
    } finally {
      this.loading = false;
    }
  }
  async setUserRole(role: number, uid: number) {
    // 0普通 1推广员
    const res = await getUserRole({ role: role, uid: uid });
    if (res && res.code == 0) {
      this.getList();
    }
    this.loading = false;
  }
  mounted() {
    // this.start = moment(this.dates[0]).unix();
    // this.end = moment(this.dates[1]).unix();
    this.pageFn = this.getList;
    this.getList();
  }
}
